import React from 'react';
import styled, { css } from 'styled-components';
import { HELP_DESK_UNREAD_COLORS } from '@ubeya/shared/constants/helpDesk';

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${HELP_DESK_UNREAD_COLORS.text};
  color: ${({ theme }) => theme.colors.white};
  font-size: 10px;
  line-height: 14px;
  font-weight: 400;
  padding: 0 4px;
  border-radius: 100px;
  min-width: 14px;
  flex-shrink: 0;

  ${({ $isDot }) =>
    $isDot &&
    css`
      width: 14px;
      height: 14px;
      padding: 0;
    `}
`;

/**
 * Displays an unread indication: the unread message count, or an empty dot when the
 * ticket carries no new messages but the current admin marked it as unread manually.
 *
 * @param {Object} props
 * @param {number} props.count - The unread count to display
 * @param {boolean} props.isDot - Show an empty dot when there is no count
 */
const UnreadBadge = ({ count, isDot = false }) => {
  if (count > 0) return <Badge>{count}</Badge>;
  if (isDot) return <Badge $isDot />;
  return null;
};

export default UnreadBadge;
